import React, {useCallback, useEffect, useState} from "react";
import ajaxloader from "../../images/ajax-loader.gif";
import adminService from "../../services/admin.service";
import ScheduledFundScanList from "./ScheduledFundScanList";

export default function ScheduledFundScan(props) {

    const [loadStatus, setLoadStatus] = useState("idle");
    const [loadMessage, setLoadMessage] = useState("");

    const [scans, setScans] = useState([]);

    const load = useCallback(() => {
        adminService.loadLastFundScan().then(
            response => {
                setScans(response.data["data"]);
                setLoadStatus("success");
            },
            error => {
                setLoadStatus("error");
                setLoadMessage("An error occurred while loading users");
            }
        );
    }, []);

    useEffect(() => {
        if (loadStatus === "idle") {
            setLoadStatus("pending");
            load();
        }
    }, [loadStatus, load]);

    if (loadStatus !== 'success') {
        return (
            <div className="main-content">
                <div style={{margin: "1rem auto"}}>
                    <img alt="loading" src={ajaxloader}/>
                </div>
            </div>
        )
    }

    if (!scans || scans.length === 0) {
        return (
            <div className="main-content">
                <div style={{margin: "1rem auto"}}>
                    <p>No data found</p>
                </div>
            </div>
        )
    }

    return (
        <div className="main-content">
            <span className={'client-title'}>Daily fund scan</span>
            <p style={{marginTop: '20px'}}>
                Shows the latest look-through scan made for each eligible client
            </p>
            <ul>
                <li>The client must have access to the AM database</li>
                <li>The client type must be one of <b>AM / Foundation / Insurance / Pension Fund</b></li>
                <li>The numbers in parenthesis show the difference from the first scan of the week (Monday)</li>
            </ul>

            <ScheduledFundScanList tgtDataOrig={scans}/>
        </div>
    );
}